import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import ActionAreaCard from './imageCard';
import Data from '../data/data';

const Cover = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  text-align:center
`;

const ImageCover = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content:center;
  flex-wrap: wrap;
  text-align:center

`;

const useStyles = makeStyles((theme) => ({
    h2:{
   paddingBottom:'2%',
   marginTop:'50px',
   [theme.breakpoints.down('md')]:{
    width:'80%',
    margin:'auto'
   }
    },
    h5:{
      margin:'auto'
      ,
      [theme.breakpoints.down('md')]:{
        width:'80%'
       }
    },
    img:{
        width:'15%',
        margin:'2%',
        objectFit:'cover',
        [theme.breakpoints.down('md')]:{
            width:'80%'
        }
    },
    p:{
        width:'85%',
        margin:'1% auto',
        [theme.breakpoints.down('md')]:{
          width:'80%'
         }
    }
  }));


const MainData = () => {
    const style=useStyles()
  return (
    <>
      <Cover>
        <h2 className={style.h2}>How Can We Help You?</h2>
        <h5 className={style.h5}>
          Discover the latest trends and insights across finance, entertainment,
          sports, and more.
        </h5>
        <br />
        <p className={style.p}>
          Connect with a global audience of high net worth, highly educated, and
          international professionals. Stay informed and engaged with trending
          blogs covering every category, from finance to entertainment, sports
          to news.
        </p>
        <p className={style.p}>
          Our platform brings you the most up-to-date and relevant content,
          helping you stay ahead in your field and connected with the topics
          that matter most.
        </p>
        <p className={style.p}>
          Explore articles written by industry experts and join a community of
          readers who share your interests. Whether you're looking for financial
          advice, entertainment news, sports updates, or the latest headlines,
          we've got you covered.
        </p>
        <br />
      </Cover>

      <ImageCover>
        {Data.map((element) => (
          <ActionAreaCard
            className={style.img}
            title={element.title}
            desc={element.desc}
            link={element.link}
          />
        ))}
      </ImageCover>
    </>
  );
};

export default MainData;
